import React from 'react'
import { Divider, Grid, Link, Typography } from '@material-ui/core'
import {makeStyles} from '@material-ui/core/styles'
import { useIntl } from 'src/common/razzle-platform-translate'
import LoginForm from 'src/common/razzle-platform-user/Authentication/Login/LoginForm'
import {useAuth} from 'src/common/razzle-platform-user/Authentication/hooks'
import FacebookOAuth from 'src/common/razzle-platform-user/Authentication/OAuth/FacebookOAuth'
import GoogleOAuth from 'src/common/razzle-platform-user/Authentication/OAuth/GoogleOAuth'
import {
    BASE_URL,
    SOCIAl_OAUTH_ENABLED,
    FACEBOOK_OAUTH_KEY,
    GOOGLE_OAUTH_KEY
} from 'src/common/razzle-platform-user/configs'


const useStyles = makeStyles(theme => ({
    container: {
        paddingBottom: 30,
        paddingLeft: 10,
        paddingRight: 10
    },
    titleContainer: {
        marginBottom: 10
    },
    title: {
        marginTop: 0
    },
    dividerContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: 24,
        marginBottom: 24
    },
    divider: {
        width: 50
    },
    or: {
        marginLeft: 8,
        marginRight: 8,
        fontWeight: 'bold'
    },
    forgotPassword: {
        marginTop: 10
    },
    registerLink: {
        marginLeft: 10
    }
}))


const Login = (props) => {

    const { displayRegister } = useAuth()
    const classes = useStyles(props)
    const { formatMessage } = useIntl()

    return (
        <div className={classes.container}>
            <Grid container={true} item={true} xs={12} direction="row" justify="center" className={classes.titleContainer}>
                <h1 className={classes.title} >{formatMessage({ id: 'Connexion', defaultMessage: 'Connexion' })}</h1>
            </Grid>
            <LoginForm
                textField={props.textField}
                passwordField={props.passwordField}
                checkBoxField={props.checkBoxField}
                submitButton={props.submitButton}
             />
            { SOCIAl_OAUTH_ENABLED  && (GOOGLE_OAUTH_KEY || FACEBOOK_OAUTH_KEY) &&
                <div className={classes.dividerContainer}>
                    <Divider className={classes.divider} />
                        <span className={classes.or} >OR</span>
                    <Divider className={classes.divider} />
                </div>
            }
            <Grid container={true} spacing={2}>
                {SOCIAl_OAUTH_ENABLED && GOOGLE_OAUTH_KEY &&
                    <Grid container={true} item={true} xs={12} direction="row" justify="center">
                        <Grid item={true} xs={9} md={9}>
                            <GoogleOAuth googleButton={props.googleButton} />
                        </Grid>
                    </Grid>
                }
                {SOCIAl_OAUTH_ENABLED && FACEBOOK_OAUTH_KEY &&
                    <Grid container={true} item={true} xs={12} direction="row" justify="center">
                        <Grid item={true} xs={9} md={9}>
                            <FacebookOAuth facebookButton={props.facebookButton} />
                        </Grid>
                    </Grid>
                }
                <Grid container={true} item={true} xs={12} direction="row" justify="center" className={classes.forgotPassword}>
                    <Link href={`${BASE_URL}app/reset`} target="_blank" variant="body2" >
                        {formatMessage({ id: 'Mot de passe oublié?', defaultMessage: 'Mot de passe oublié?' })}
                    </Link>
                </Grid>
                <Grid container justify="center">
                    <Grid item>
                        <Typography variant="body2" >{formatMessage({ id: "Je n'ai pas de compte?", defaultMessage: "Je n'ai pas de compte?" })}
                            <Link href="#" onClick={displayRegister} variant="body2" className={classes.registerLink}>
                                {formatMessage({ id: "S'inscrire", defaultMessage: "S'inscrire" })}
                            </Link>
                        </Typography>
                    </Grid>
                </Grid>

            </Grid>

        </div>
    )
}

export default Login
